import "./product.css";
import React from "react";


const Product = () => {
  return (
    <div>
        <h1>HElllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllo</h1>
    </div>
  );
}



export default Product;
